<template>
  <div>
    <el-dialog
      title="Edit image"
      append-to-body
      width="90vw"
      top="4vh"
      :visible.sync="dialogFormVisible"
    >
      <image-form
        :id="id"
        inModal
        @submit="submitForm"
        :only-show-short-crop="onlyShowShortCrop"
        :only-show-small-crop="onlyShowSmallCrop"
        :only-show-normal-crop="onlyShowNormalCrop"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm()">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImageForm from '@/views/Image/ImageForm'

export default {
  data() {
    return {
      dialogFormVisible: false,
      id: null
    }
  },
  props: {
    onlyShowNormalCrop: {
      default: false
    },
    onlyShowShortCrop: {
      default: false
    },
    onlyShowSmallCrop: {
      default: false
    }
  },
  methods: {
    openDialog(value) {
      this.id = value
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },
    submitForm() {
      this.dialogFormVisible = false
      this.$emit('formSubmitted')
    }
  },
  components: {
    ImageForm
  }
}
</script>
